import React from "react";
import Paper from "material-ui/Paper";

import connectToStores from "alt-utils/lib/connectToStores";
import NoteActions from "../../../actions/NoteActions";
import NoteStore from "../../../stores/NoteStore";

import WorkingIndicator from "../working-indicator.jsx";

import Note from "./note.jsx";
import AddNote from "./add-note.jsx";

class Notes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounting: true
    };
  }

  static getStores() {
    return [NoteStore];
  }

  static getPropsFromStores() {
    let { isFetching, isEditing, isCreating } = NoteStore.getState();
    return {
      getNotesForPerson: NoteStore.getNotesForPerson,
      getNotesForOrder: NoteStore.getNotesForOrder,
      isFetching,
      isEditing,
      isCreating
    };
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.order) {
        NoteActions.fetchAllForOrder(this.props.order)
      } else if (this.props.person) {
        NoteActions.fetchAllForPerson(this.props.person);
      }
      this.setState({ isMounting: false });
    }, 0);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.person !== this.props.person) {
      NoteActions.fetchAllForPerson.defer(newProps.person);
    }

    if (newProps.order !== this.props.order) {
      NoteActions.fetchAllforOrder.defer(newProps.order);
    }
  }

  render() {
    if (this.props.isFetching || this.state.isMounting) {
      return <WorkingIndicator centered />;
    }

    let personNotes = this.props.getNotesForPerson(this.props.person).sort((a, b) => {
      return a.updated_at < b.updated_at;
    });

    let orderNotes = this.props.getNotesForOrder(this.props.order).sort((a, b) => {
      return a.updated_at < b.updated_at;
    });

    const notes = [...personNotes, ...orderNotes];

    return (
      <div>
        <AddNote
          person={this.props.person}
          isCreating={this.props.isCreating}
          order={this.props.order}
        />
        {notes.map(note => (
          <Note
            key={note.id}
            note={note}
            person={this.props.person}
            isSaving={note.id === this.props.isEditing}
            order={this.props.order}
          />
        ))}
      </div>
    );
  }
}

export default connectToStores(Notes);



// WEBPACK FOOTER //
// ./src/app/components/partials/notes/notes.jsx